// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2021-06-29T10:20:47+00:00
//    Cause:          Commit 774fce6e44b61cb86e8f57ecdb2a8e9f062e5d1c by jameswelch
//    Deployment ID:  129531
//    Project:        315
//    Environment:    667 - master
//    MD5:            402bf5be70d0f2d6720d19e8c2056533
//    Signature:      eyJpdiI6InR3dU1RMDV4SDNhNXNRZXFLUG0wN2c9PSIsInZhbHVlIjoiZjFXVmxWcEtNazQ4YldFM1wvRFwvRlZ6TFF0ZzhabWlpSXpLTTdTR0RScG1tV0dMSnE5MGdLNVpDR0VTeXNcL3htRlFyNDZiMFdRVzRmaHg0UlZSM0YrRlRKTzBFWHl2REp4ODF6Yzh6QjNoV0xpSmMzV3ZkcFp5Vkl6U0RiQXJqaVRcLzZ2c1dvSmlDeTZGbitzSHNDRCtvKzlwWUNHTXgwUWxJNGFKU0Zhd0NrQmlrNFJZTEhMalJvMnl5TFhKbUVVcHpZWEU1TlwvbUpqVFF6Q1ptbXFcL2U1aGdkWDN1UlwvWXhJWUJzM1F3ZEdia1VodlRCZVVTK3pJRUVsditlQjIwalwvM3VxY1pcL1djTWN2eFVqZFcxRjdMTnVcL3NZWDYyZDdhSVpwRnRWRTlOY3h5YVNCeGZXZ2h4aks1RzJnNHQ4M2ZYZ0FNSitrRHVCOUxuN2RKajZwdjdldGIzMGQ5Qnp4MUQxaGIwXC83UThCRnBkMjlQcFV5XC95V3hoODVrRTVDeGltTU5PRlo2QUw3U1Y5aXNWZGREcVR5YlF5S1BpY2N0ZjdDZE4wampNMkJDVThONlh2TkFzNlpzckxObGpwQjZSRE9yRnJsWWtcL1VaMWE5NlJmRyttODlRPT0iLCJtYWMiOiJlMjAxMGY0MDQwNDczZDEwMjE3YjUxNDdkZGMwN2JjNDJjMGZmMGFkOWUzNDRjODVhYTgyNmE4YzViNGVjMGVhIn0=
function HasClass( el, cls )
{
    var current = el.getAttribute( "class" );
    return ( ( current != undefined ) && ( current.indexOf( cls ) != -1 ) );
}

function AddClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( ( current == undefined ) || ( current.indexOf( cls ) == -1 ) )
        {
            current += " " + cls;
            el.setAttribute( "class", current );
        }
    }
}
function RemoveClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( current )
        {
            current = current.replace( cls, ' ' );
            el.setAttribute( "class", current );
        }
    }
}
function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function ParseQP( )
{
    var qpd   = { };
    var qp    = window.location.search.substr( 1 );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}

function stopPropagation( e )
{
    if( e )
    {
        e.preventDefault();
        e.stopPropagation();
    }
    else
    {
        window.event.preventDefault();
        window.event.stopPropagation();
    }
}

function SendAPIRequest( url, method, params, cb )
{
    var xhr = new XMLHttpRequest( );   

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            //console.log( "rx response " + xhr.responseText );
            if ( cb )
            {
                var parsed;

                var ct = xhr.getResponseHeader( "Content-Type" );
                if ( ( ct ) && ( ct.indexOf( "json" ) >= 0 ) && ( xhr.responseText ) )
                {
                    try
                    {
                        parsed = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                        console.log( "error parsing JSON response : " + e.stack );
                    }
                }

                cb( xhr, parsed );
            }
            else
            {
                if ( xhr.status == 200 )
                {
                    window.location.reload( );
                }
            }
        }
    };

    //console.log( "requesting " + method + " from " + url );
    if ( params )
    {
        xhr.open( method, url, true );
        xhr.setRequestHeader( "Content-Type", "application/json" );
        xhr.send( JSON.stringify( params ) );
    }
    else
    {
        xhr.open( method, url, true );
        xhr.send( );
    }
}

function UnHideSlickSliders()
{
    var hiddenSlickSliders = document.querySelectorAll( ".hidden-slide-until-loaded" );
    for( var i = 0; i < hiddenSlickSliders.length; i++ )
    {
        var hiddenSlickSlider = hiddenSlickSliders[ i ];
        hiddenSlickSlider.classList.remove( "hidden-slide-until-loaded" );
        // RemoveClass( hiddenSlickSlider, "hidden-slide-until-loaded" );
    }
}

window.addEventListener( "load", function( e )
{
    UnHideSlickSliders();
} );